import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import DatePicker from 'react-datepicker';

import { CustomValueContainer } from '../../components/react_select/ReactSelect';

const styles_select = {
    menuPortal: base => ({ ...base, zIndex: 9999 }),
    container: (provided) => ({ ...provided }),
    control: (provided) => ({ ...provided, paddingTop: '5px', paddingBottom: '5px' }),
    valueContainer: (provided) => ({ ...provided, overflow: 'visible', marginTop: '10px' }),
    placeholder: (provided, state) => ({
        ...provided,
        position: 'absolute',
        top: state.hasValue || state.selectProps.inputValue ? -15 : '0%',
        transition: 'top 0.1s, font-size 0.1s',
        fontSize: (state.hasValue || state.selectProps.inputValue) && 13
    })
};

const opcionesStatus = [
    { value: true, label: 'Revisada' },
    { value: false, label: 'Pendiente' }
];

const FiltrosRevision = ({ show, handleCerrar, filtros, handleAplicar }) => {

    const sucursalesListado = useSelector(state => state.sucursales.listado);
    const empleadosListado = useSelector(state => state.empleados.listado);

    const [sucursalData, setSucursalData] = useState(null);
    const [responsableData, setResponsableData] = useState(null);
    const [statusData, setStatusData] = useState(null);
    const [fechaCreacionInicio, setFechaCreacionInicio] = useState(null);
    const [fechaCreacionFin, setFechaCreacionFin] = useState(null);
    const [fechaRevisionInicio, setFechaRevisionInicio] = useState(null);
    const [fechaRevisionFin, setFechaRevisionFin] = useState(null);

    useEffect(() => {
        if (show) {
            setStatusData(filtros.status !== null ? opcionesStatus.find(o => o.value === filtros.status) ?? null : null);
            setFechaCreacionInicio(filtros.fecha_creacion_inicio ? new Date(filtros.fecha_creacion_inicio) : null);
            setFechaCreacionFin(filtros.fecha_creacion_fin ? new Date(filtros.fecha_creacion_fin) : null);
            setFechaRevisionInicio(filtros.fecha_revision_inicio ? new Date(filtros.fecha_revision_inicio) : null);
            setFechaRevisionFin(filtros.fecha_revision_fin ? new Date(filtros.fecha_revision_fin) : null);

            const sucOpc = sucursalesListado.map(s => ({ value: s._id, label: s.nombre }));
            setSucursalData(filtros.sucursal ? sucOpc.find(s => s.value === filtros.sucursal) ?? null : null);

            const empOpc = empleadosListado.map(e => ({
                value: e._id,
                label: `${e.nombre || ''} ${e.apellido_paterno || ''} ${e.apellido_materno || ''}`.trim()
            }));
            setResponsableData(filtros.responsable ? empOpc.find(e => e.value === filtros.responsable) ?? null : null);
        }
    }, [show]);

    const handleAplicarFiltros = () => {
        handleAplicar({
            sucursal: sucursalData ? sucursalData.value : null,
            responsable: responsableData ? responsableData.value : null,
            status: statusData ? statusData.value : null,
            fecha_creacion_inicio: fechaCreacionInicio ? new Date(new Date(fechaCreacionInicio).setHours(0, 0, 0, 0)) : null,
            fecha_creacion_fin: fechaCreacionFin ? new Date(new Date(fechaCreacionFin).setHours(23, 59, 59, 999)) : null,
            fecha_revision_inicio: fechaRevisionInicio ? new Date(new Date(fechaRevisionInicio).setHours(0, 0, 0, 0)) : null,
            fecha_revision_fin: fechaRevisionFin ? new Date(new Date(fechaRevisionFin).setHours(23, 59, 59, 999)) : null
        });
        handleCerrar();
    };

    const handleLimpiar = () => {
        setSucursalData(null);
        setResponsableData(null);
        setStatusData(null);
        setFechaCreacionInicio(null);
        setFechaCreacionFin(null);
        setFechaRevisionInicio(null);
        setFechaRevisionFin(null);
        handleAplicar({
            sucursal: null, responsable: null, status: null,
            fecha_creacion_inicio: null, fecha_creacion_fin: null,
            fecha_revision_inicio: null, fecha_revision_fin: null
        });
        handleCerrar();
    };

    const sucursalesOpciones = sucursalesListado.map(s => ({ value: s._id, label: s.nombre }));
    const responsablesOpciones = empleadosListado.map(e => ({
        value: e._id,
        label: `${e.nombre || ''} ${e.apellido_paterno || ''} ${e.apellido_materno || ''}`.trim()
    }));

    return (
        <Modal show={show} size="lg" backdrop="static" centered onHide={handleCerrar}>
            <Modal.Header closeButton>
                <Modal.Title>Filtros</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row g-3">

                    <div className="col-6 form-group">
                        <div className="input-group h-100">
                            <Select
                                className="select-group w-100"
                                classNamePrefix="react-select"
                                placeholder="Sucursal"
                                options={sucursalesOpciones}
                                value={sucursalData}
                                onChange={option => setSucursalData(option)}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                                isClearable
                            />
                        </div>
                    </div>

                    <div className="col-6 form-group">
                        <div className="input-group h-100">
                            <Select
                                className="select-group w-100"
                                classNamePrefix="react-select"
                                placeholder="Responsable"
                                options={responsablesOpciones}
                                value={responsableData}
                                onChange={option => setResponsableData(option)}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                                isClearable
                            />
                        </div>
                    </div>

                    <div className="col-4 form-group">
                        <div className="input-group h-100">
                            <Select
                                className="select-group w-100"
                                classNamePrefix="react-select"
                                placeholder="Status"
                                options={opcionesStatus}
                                value={statusData}
                                onChange={option => setStatusData(option)}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                                isClearable
                            />
                        </div>
                    </div>

                    <div className="col-12">
                        <hr className="my-1" />
                        <small className="text-muted">Fecha de creación</small>
                    </div>

                    <div className="col-6">
                        <div className="input-group">
                            <div className="form-floating">
                                <DatePicker
                                    id="filtro_fecha_creacion_inicio"
                                    className="form-control text-center input-datepicker"
                                    selected={fechaCreacionInicio}
                                    onChange={date => setFechaCreacionInicio(date)}
                                    dateFormat="dd/MM/yyyy"
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    isClearable
                                    autoComplete="off"
                                />
                                <label className="label-datepicker" htmlFor="filtro_fecha_creacion_inicio">Fecha inicio</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-6">
                        <div className="input-group">
                            <div className="form-floating">
                                <DatePicker
                                    id="filtro_fecha_creacion_fin"
                                    className="form-control text-center input-datepicker"
                                    selected={fechaCreacionFin}
                                    onChange={date => setFechaCreacionFin(date)}
                                    dateFormat="dd/MM/yyyy"
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    isClearable
                                    autoComplete="off"
                                    minDate={fechaCreacionInicio}
                                />
                                <label className="label-datepicker" htmlFor="filtro_fecha_creacion_fin">Fecha fin</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-12">
                        <hr className="my-1" />
                        <small className="text-muted">Fecha de revisión</small>
                    </div>

                    <div className="col-6">
                        <div className="input-group">
                            <div className="form-floating">
                                <DatePicker
                                    id="filtro_fecha_revision_inicio"
                                    className="form-control text-center input-datepicker"
                                    selected={fechaRevisionInicio}
                                    onChange={date => setFechaRevisionInicio(date)}
                                    dateFormat="dd/MM/yyyy"
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    isClearable
                                    autoComplete="off"
                                />
                                <label className="label-datepicker" htmlFor="filtro_fecha_revision_inicio">Fecha inicio</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-6">
                        <div className="input-group">
                            <div className="form-floating">
                                <DatePicker
                                    id="filtro_fecha_revision_fin"
                                    className="form-control text-center input-datepicker"
                                    selected={fechaRevisionFin}
                                    onChange={date => setFechaRevisionFin(date)}
                                    dateFormat="dd/MM/yyyy"
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    isClearable
                                    autoComplete="off"
                                    minDate={fechaRevisionInicio}
                                />
                                <label className="label-datepicker" htmlFor="filtro_fecha_revision_fin">Fecha fin</label>
                            </div>
                        </div>
                    </div>

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-outline-secondary me-auto" onClick={handleLimpiar}>
                    <i className="fas fa-times me-1"></i> Limpiar
                </button>
                <button className="btn btn-secondary" onClick={handleCerrar}>
                    Cancelar
                </button>
                <button className="btn btn-primary" onClick={handleAplicarFiltros}>
                    <i className="fas fa-filter me-1"></i> Aplicar
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default FiltrosRevision;
